import React, { useState,useContext, useEffect, useRef } from 'react';
import { Box, Card } from '@mui/material';
import { useTranslation } from 'react-i18next';
import imagelogosm from '../images/neubox-logo.png'
import { ReactComponent as Oxxologo } from '../images/oxxo-logo.svg';
import { ReactComponent as BarCode } from '../images/bar-code.svg';
import Button from '@mui/material/Button';
import { ReactComponent as PrintIcon } from '../images/print.svg';
import "../styles/OxxoPay.scss";
import { useReactToPrint } from 'react-to-print';
import { useLocation } from 'react-router-dom';
import Loader from '../components/Loader';
import { addOrderOxxo, setSignalDataOxxo } from '../services/Payments/Oxxo/addOrderOxxo';
import { showErrorAlert } from "../alerts/Error";
import { AuthContext } from '../Auth';
import Base64ImageComponent from '../components/Checkout/Payments/Base64ImageComponent';
import { useNavigate, useParams } from 'react-router-dom';
import formatCurrency from '../helpers/formatCurrency';
import { useDispatch, useSelector } from 'react-redux';
import { clearProfileDataAfterBuy } from '../slices/profileSlice';
import { clearGlobalDataAfterBuy } from '../globalslice';

const VoucherOxxo = () => {
const { t } = useTranslation();
const location = useLocation();
const [loader, setLoader] = useState(false);
const { userAuth, setShowLoginExpired } = useContext(AuthContext);
const [data, setData] = useState({});
const initialized = useRef(false)
const navigate = useNavigate();
const { invoiceId } = useParams();
const dispatch = useDispatch();
const profile = useSelector(state => state.profile);
const descuento = useSelector(state => state.global.descuento);
const currency = useSelector((state) => state.global.currency);
const contentToPrint = useRef(null);

  const handlePrint = useReactToPrint({
    documentTitle: "Print This Document",
    onBeforePrint: () => console.log("before printing..."),
    onAfterPrint: () => console.log("after printing..."),
    removeAfterPrint: true,
  });

  const init = async (invoiceId) => {
    let res;
    setLoader(true);

    if (invoiceId != null) {
        //viene del viewinvoice
        res = await addOrderOxxo([], userAuth?.token, invoiceId);
    } else {
        //viene del carrito checkout
        let products = location?.state?.products
        res = await addOrderOxxo(products, userAuth?.token, null, profile.facturacionAutomatica, profile.discount.nbps, descuento);
    }
    setLoader(false)

    if(res && res.success === true) {
        const data = res.data
        setData(data)
        // restablece datos después de la compra
        if (! invoiceId) {
            dispatch(clearProfileDataAfterBuy());
            dispatch(clearGlobalDataAfterBuy());
        }
    } else {
        if (res?.result === 'error' && res?.error === 'session') {
            setShowLoginExpired(true);
        } else {
            if(res?.result === 'error' || res?.success == false) {
                const timer = setTimeout(() => {
                    navigate(-1); // Navigate back to the previous screen
                }, 3000);
            showErrorAlert(
                {
                    title: t("error.transaction.title"),
                    text: t("error.transaction.text"),
                },
                timer
                );
            }
        }
    }
  };

  const redirectToValidateView = () => {
    const clientesURL = process.env.REACT_APP_CLIENTES_URL;
    window.location.href = clientesURL;
  };

  useEffect(() => {
    const abortController =  new AbortController();

    if(userAuth?.token){
        if (!initialized.current) {
            initialized.current = true
            setSignalDataOxxo(abortController.signal);
    
            //make request
            init(invoiceId);
        }
    } else {
        // si no existe sesión, se le obliga a iniciar sesión al cliente
        setShowLoginExpired(true);
    }

    return () => {
        abortController.abort();
    };
  }, [location, userAuth]);

  return (
    <Card variant="outlined" style={{ padding: '32px',backgroundColor: '#EAEAEA' }}>
        <Loader open={loader} />
        {!loader && userAuth?.token && <Card variant="outlined" ref={contentToPrint} className="print-card"  style={{ backgroundColor: '#FFFFFF', display:'flex', flexDirection: 'column'}}>
            <div className='oxxo-head'>
                <p>{t('oxxoPay.head')}</p>
            </div>
            <img style={{alignSelf: 'center', marginTop:'32px'}} src={imagelogosm} height={50} width={198} alt="Logo Neubox" className="h-logo1" />
            <div className='oxxo-texts'>
                <p className='oxxo-title'>{t('oxxoPay.title')}</p>
                <p className='oxxo-description'> {t('oxxoPay.description')}</p>
                <p className='oxxo-mount-text'> {t('oxxoPay.mountText')}</p>
                <p className='oxxo-mount'>{formatCurrency(data.amount, 'MXN')}</p>
                <p className='oxxo-mount-disclaimer'> {t('oxxoPay.mountDisclaimer')}</p>
            </div>
            <Box
            className='details-print'
            sx={{
                width: '80%',
                margin: '25px auto',
                p: 3,
                borderRadius: '8px',
                backgroundColor: '#2287B80D',
            }}
        >
            <div style={{ display: 'flex',
                justifyContent: 'space-between', 
                alignItems: 'center'}} >
                <div>
                    <p className="details-title">{t('oxxoPay.details')}</p>
                    <p className='details-body'>
                        {t('oxxoPay.orgName')}: <strong>NEUBOX</strong>
                        <br />
                        {t('oxxoPay.expiryDate')}: <strong>{data.expires_at}</strong>
                        <br />
                        {t('oxxoPay.concept')}: <strong>{data.concepto}</strong>
                    </p>
                </div>
                <Oxxologo style={{ marginLeft: 'auto' }} /> 
            </div>

            <p className='details-disclaimer'>{t('oxxoPay.detailsDisclaimer')}</p>
            <p className='details-reference'>{t('oxxoPay.reference')}</p>
            <div style={{display: 'flex',  justifyContent: 'center', alignItems:'center', flexDirection: 'column'}}>
                {/* <BarCode /> */}
                <Base64ImageComponent base64={data.base64} imageType="png" alt="Sample Image" />
                <p className='reference'>{data.reference}</p>
            </div>
        </Box>
        <Box
            sx={{
                width: '80%',
                margin: '25px auto',
                p: 3
            }}
        >
        <div className='oxxo-instructions'>
            <p className='title'>{t('oxxoPay.instructions.title')}</p>
            <p className='step'>1. {t('oxxoPay.instructions.one')} <a href="https://www.google.com/maps/search/OXXO+cerca+de+mi" target="_blank" rel="noopener noreferrer">{t('oxxoPay.instructions.oneLine')}</a></p>
            <p className='step'>2. {t('oxxoPay.instructions.two')}</p> 
            <p className='step'>3. {t('oxxoPay.instructions.three')} <b>{t('oxxoPay.instructions.threeBlack')}</b></p>
            <p className='step'>4. {t('oxxoPay.instructions.four')} <b>{t('oxxoPay.instructions.fourBlack')}</b></p>
            <p className='step'>5. {t('oxxoPay.instructions.five')}</p> 
            <div className='non-printable' dangerouslySetInnerHTML={{ __html: t("oxxoPay.instructions.last") }} />
        </div>
        </Box>
        <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'center', alignContent: 'center'}}>
        <Button
            className='non-printable'
            onClick={() => {
            handlePrint(null, () => contentToPrint.current);
          }}
            variant="contained"
            sx={{
                mb: 8,
                width: '250px',
                height: '60px',
                alignSelf: 'center',
                textTransform: 'none',
                backgroundColor: '#2C92D0',
                fontFamily: 'Patua One, sans-serif',
                fontSize: '16px',
            }}
            startIcon={<PrintIcon />} // Icon on the left
        >
            {t('oxxoPay.printText')}
        </Button>
        <button style={{width: '250px', height: '60px', marginLeft: 16}} className="btn btn-success non-printable" onClick={redirectToValidateView}>
                {t("spei.btn.continue")}
        </button>
        </div>
        
        </Card> 
        }
    </Card>    
  )
}

export default VoucherOxxo